module.exports = __webpack_public_path__ + "img/SEJ enventos_logo recrea_gris.32b03daa.svg";